export default "__VITE_ASSET__CiiVO_yD__"